module.exports = __webpack_public_path__ + "img/dark-green-circle-table-2.be44797f.png";